// extracted by mini-css-extract-plugin
export default {"heading":"Dt-z","corrected":"Et-z","redirectVerbiageContainer":"Ft-z","redirectVerbiageText":"Gt-z"};